import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import NavbarCont from "../Navbar/NavbarCont";
import { useParams } from "react-router-dom";
import { useDBContext } from "../Context/DBcontext";
import MidItem from "../Home/Mid/MidItem";
import ArticleSectionItem from "./ArticleSectionItem";
export default function ArticleSectionCont() {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 6; // Número de artículos por página

  useEffect(() => {
    setCurrentPage(1);
  }, [id]);

  function reemplazarGuionesPorEspacios(texto) {
    return texto.replace(/-/g, " ");
  }

  const { articles, getArticles } = useDBContext();

  useEffect(() => {
    if (articles.length === 0) {
      getArticles();
    }
  }, []);

  let newId = id === "notas-de-tapa" ? "Nota de tapa" : id;

  let articlesOfThisCategory = id !== "all" ? articles.filter(
    (e) =>
      e.category.toUpperCase() ===
      reemplazarGuionesPorEspacios(newId).toUpperCase()
  ) : articles

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articlesOfThisCategory.slice(
    indexOfFirstArticle,
    indexOfLastArticle
  );

  const totalPages = Math.ceil(articlesOfThisCategory.length / articlesPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="home-cont">
      <NavbarCont />
      <div className="article-section-cont">
        <p className="article-section-news-title">
          {" "}
          <img
            width="18"
            height="18"
            src="https://img.icons8.com/ios-filled/50/ffffff/magazine.png"
            alt="read"
          />{" "}
          {reemplazarGuionesPorEspacios(id === "all" ? "River para leer" : id ).toUpperCase()}
        </p>

        <div className="mid-cont">
          {currentArticles.map((e, index) => (
            <ArticleSectionItem key={index} {...e} />
          ))}
        </div>
      </div>

      <div className="pagination-cont">
        <div className="row gap05rem">
          <button
            className="buttonbyn"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Anterior
          </button>

          <button
            className="buttonbyn"
            onClick={nextPage}
            disabled={currentPage === totalPages}
          >
            Siguiente
          </button>
        </div>
        <span>
          Página {currentPage} de {totalPages}
        </span>
      </div>

      <Footer />
    </div>
  );
}
